export const DPIStatus = {
	1: 'Open',
	2: 'Submitted',
	3: 'Approved As Is',
	4: 'Substantially Approved',
	5: 'Inactive',
	6: 'Denied',
	7: 'Not Funded',
};
